import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosConfig';
import { saveAs } from 'file-saver';
import * as pdfjsLib from 'pdfjs-dist';
// import { pdfjs } from "react-pdf";
import { IconButton, Box, Alert, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download'; // Download Icon
import './SchoolProfileVerification.css';

const pdfjs = await import('pdfjs-dist/build/pdf');

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const SchoolProfileVerification = () => {
  const [users, setUsers] = useState([]);
  const [modifiedUsers, setModifiedUsers] = useState([]);
  const [pdfPreviewUrls, setPdfPreviewUrls] = useState({});
  const [alert, setAlert] = useState(null);
      
  useEffect(() => {
    if (alert && alert.severity !== "info") {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 3000); // 3 Sekunden Timeout
  
      return () => clearTimeout(timer); // Cleanup-Funktion für den Timer
    }
  }, [alert]);

  useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.get('/admin/users', {
        headers: {
          Authorization: `${token}`,
        },
      });
      setUsers(response.data);

      // Generiere Vorschau-Bilder für alle PDF-Dateien
      response.data.forEach((user) => {
        if (user.schoolVerificationDocument && user.schoolVerificationDocument.endsWith('.pdf')) {
          generatePdfPreview(user.schoolVerificationDocument, user._id);
        }
      });
    };
    fetchUsers();
  }, []);

  const generatePdfPreview = async (pdfUrl, userId) => {
    try {
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const scale = 1.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;

      const previewUrl = canvas.toDataURL(); // Vorschau-Bild als Data-URL
      setPdfPreviewUrls((prev) => ({ ...prev, [userId]: previewUrl }));
    } catch (error) {
      console.error('Fehler beim Laden der PDF-Vorschau:', error);
    }
  };

  const handleDownload = (fileUrl) => {
    saveAs(fileUrl, 'school-verification-document');
  };

  const handleVerificationChange = (index, isVerified) => {
    const updatedUsers = [...users];
    updatedUsers[index].schoolVerified = isVerified;
    setUsers(updatedUsers);

    if (!modifiedUsers.find((user) => user._id === updatedUsers[index]._id)) {
      setModifiedUsers([...modifiedUsers, updatedUsers[index]]);
    }
  };

  const handleIsProfileCompleteChange = (index, isProfileComplete) => {
    const updatedUsers = [...users];
    updatedUsers[index].schoolProfileComplete = isProfileComplete;
    setUsers(updatedUsers);

    if (!modifiedUsers.find((user) => user._id === updatedUsers[index]._id)) {
      setModifiedUsers([...modifiedUsers, updatedUsers[index]]);
    }
  };

  const handleSubmitChanges = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const response = await axiosInstance.put('/admin/users/update', modifiedUsers, {
        headers: {
          Authorization: `${token}`,
        },
      });
  
      // Wenn die Antwort erfolgreich ist (Statuscode 2xx), Erfolgsmeldung anzeigen
      if (response.status >= 200 && response.status < 300) {
        setAlert({
          severity: "success",
          message: "Änderungen erfolgreich übernommen."
        });
      }
    } catch (error) {
      // Bei einem Fehler die Fehlermeldung anzeigen
      setAlert({
        severity: "error",
        message: "Fehler beim Übernehmen der Änderungen. Bitte versuchen Sie es erneut."
      });
    }
  };

  return (
    <Box sx={{ ml: '1rem', mr: '1rem', overflowX: 'auto' }}>
    {alert && (
      <Box sx={{ marginTop: '1rem'}}>
        <Alert severity={alert.severity}>
          {alert.message}
        </Alert>
      </Box>
    )}
    <Box sx={{ minWidth: '100%', overflowX: 'auto' }}>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Schulprofil</th>
            {/* <th>Schulprofil vollständig</th> */}
            <th>Verifiziert</th>
            <th>Nachweis</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user._id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.schoolName ? user.schoolName : 'Kein Schulprofil'}</td>
              {/* <td>
                <input
                  type="checkbox"
                  checked={user?.schoolProfileComplete || false}
                  onChange={(e) => handleIsProfileCompleteChange(index, e.target.checked)}
                />
              </td> */}
              <td>
                <input
                  type="checkbox"
                  checked={user?.schoolVerified || false}
                  onChange={(e) => handleVerificationChange(index, e.target.checked)}
                />
              </td>
              <td className="preview-container">
                {user.schoolVerificationDocument ? (
                  user.schoolVerificationDocument.endsWith('.pdf') ? (
                    <div className="preview-item">
                      {pdfPreviewUrls[user._id] ? (
                        <Box className="preview-item">
                          <img src={pdfPreviewUrls[user._id]} alt="PDF Vorschau" width="100" />
                          <IconButton
                            onClick={() => handleDownload(user.schoolVerificationDocument)}
                            className="download-button"
                          >
                            <DownloadIcon />
                          </IconButton>
                        </Box>
                      ) : (
                        <p>Kein Nachweis vorhanden</p>
                      )}
                    </div>
                  ) : (
                    <div className="preview-item">
                      <img src={user.schoolVerificationDocument} alt="Nachweis" width="100" />
                      <IconButton
                        onClick={() => handleDownload(user.schoolVerificationDocument)}
                        className="download-button"
                      >
                        <DownloadIcon />
                      </IconButton>
                    </div>
                  )
                ) : (
                  'Kein Nachweis vorhanden'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </Box>
      <Button variant="contained" size="small" color="primary" onClick={handleSubmitChanges} sx={{ mb: 2, bgcolor: 'primary.light', '&:hover': { color: '#fff' } }} type="button">
        Änderungen übernehmen
      </Button>
    </Box>
  );
};

export default SchoolProfileVerification;
